import React, {useEffect, useState} from "react";
import Carousel from "react-elastic-carousel";
import { apiUrl } from "../../../services/constants";
import { Container } from 'react-bootstrap';

const newProducts = () => {

    const [data, setData] = useState(null);


    const fetchGraphQL = async (endpoint) => {
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });
        if (!response.ok) throw new Error(`Error: ${response.status}`);
        return response.json();
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [newProducts] = await Promise.all([
                    fetchGraphQL('/api/graphql/get-new-products'),
                ]);
                setData({newProducts});
            } catch (error) {
               console.error('Error!!!')
            }
        };

        void fetchData();
    }, []);




    const breakPoints = [
        { width: 1, itemsToShow: 1 },
        { width: 550, itemsToShow: 2 },
        { width: 768, itemsToShow: 3 },
        { width: 1200, itemsToShow: 4 }
    ];

    const handleProduct = (item) => {
        // console.log(item);
    }


    return (
        <div className='new-products' id='new_products'>
            <h2 className='new-products-title'>New Products</h2>
            <Container className='new-products-slide mt-5'>
                <Carousel breakPoints={breakPoints}>
                    {data && data.newProducts.data.newProducts.data.map((item, index) => {
                        return (
                            <div className="product-slide" key={index} onClick={() => handleProduct(item)}>
                                <img alt="100%x280" src={apiUrl + item.attributes.image.data.attributes.url} className="new-product-image" />
                                <div className="card-body mt-3">
                                    <h4 className="card-title">{item.attributes.product_name}</h4>
                                    <p className="card-text mt-3">{item.attributes.product_category.data.attributes.name}</p>
                                    <p className="card-text">{item.attributes.lumen_output}</p>
                                </div>
                            </div>
                        )
                    }
                    )}
                </Carousel>
            </Container>
        </div>
    )
}

export default newProducts;
